/**
 * Action de la partie commande
 */
export const SEARCH_COMMANDS = 'SEARCH_COMMANDS';
export const SEARCH_COMMANDS_SUCCESS = 'SEARCH_COMMANDS_SUCCESS';
export const SEARCH_COMMANDS_FAILURE = 'SEARCH_COMMANDS_FAILURE';

export const searchCommands = params => ({
  type: SEARCH_COMMANDS,
  payload: params
});

export const GET_COMMAND = 'GET_COMMAND';
export const GET_COMMAND_SUCCESS = 'GET_COMMAND_SUCCESS';
export const GET_COMMAND_FAILURE = 'GET_COMMAND_FAILURE';

export const getCommand = commandId => ({
  type: GET_COMMAND,
  payload: commandId
});

export const CLOSE_DRAWER = 'CLOSE_DRAWER';
export const closeDrawer = () => ({ type: CLOSE_DRAWER });

export const UPDATE_COMMAND = 'UPDATE_COMMAND';
export const UPDATE_COMMAND_FAILURE = 'UPDATE_COMMAND_FAILURE';
export const UPDATE_COMMAND_SUCCESS = 'UPDATE_COMMAND_SUCCESS';

export const updateCommand = data => ({ type: UPDATE_COMMAND, payload: data });

export const UPDATE_ITEMS = 'UPDATE_ITEMS';
export const UPDATE_ITEMS_FAILURE = 'UPDATE_ITEMS_FAILURE';
export const UPDATE_ITEMS_SUCCESS = 'UPDATE_ITEMS_SUCCESS';

export const updateItems = data => ({ type: UPDATE_ITEMS, payload: data });

export const UPDATE_COMMAND_ADDRESS = 'UPDATE_COMMAND_ADDRESS';
export const UPDATE_COMMAND_ADDRESS_FAILURE = 'UPDATE_COMMAND_ADDRESS_FAILURE';
export const UPDATE_COMMAND_ADDRESS_SUCCESS = 'UPDATE_COMMAND_ADDRESS_SUCCESS';

export const updateCommandAddress = data => ({
  type: UPDATE_COMMAND_ADDRESS,
  payload: data
});

export const UPDATE_COMMAND_OFFER = 'UPDATE_COMMAND_OFFER';
export const UPDATE_COMMAND_OFFER_FAILURE = 'UPDATE_COMMAND_OFFER_FAILURE';
export const UPDATE_COMMAND_OFFER_SUCCESS = 'UPDATE_COMMAND_OFFER_SUCCESS';

export const updateCommandoffer = data => ({
  type: UPDATE_COMMAND_OFFER,
  payload: data
});

export const ADD_CHECKED_COMMAND_ID = 'ADD_CHECKED_COMMAND_ID';
export const addCheckedCommandId = commandId => ({
  type: ADD_CHECKED_COMMAND_ID,
  payload: commandId
});

export const REMOVE_CHECKED_COMMAND_ID = 'REMOVE_CHECKED_COMMAND_ID';
export const removeCheckedCommandId = commandId => ({
  type: REMOVE_CHECKED_COMMAND_ID,
  payload: commandId
});

export const ADD_CHECKED_COMMANDS_IDS = 'ADD_CHECKED_COMMANDS_IDS';
export const REMOVE_ALL_COMMANDS_IDS = 'REMOVE_ALL_COMMANDS_IDS';

export const removeAllCommandsIds = () => ({ type: REMOVE_ALL_COMMANDS_IDS });

export const CANCEL_COMMAND = 'CANCEL_COMMAND';
export const CANCEL_COMMAND_SUCCESS = 'CANCEL_COMMAND_SUCCESS';
export const CANCEL_COMMAND_FAILURE = 'CANCEL_COMMAND_FAILURE';
export const cancelCommmand = commandId => ({
  type: CANCEL_COMMAND,
  payload: commandId
});

export const GET_RETURN_LABEL = 'GET_RETURN_LABEL';
export const GET_RETURN_LABEL_SUCCESS = 'GET_RETURN_LABEL_SUCCESS';
export const GET_RETURN_LABEL_FAILURE = 'GET_RETURN_LABEL_FAILURE';
export const getReturnLabel = commandId => ({
  type: GET_RETURN_LABEL,
  payload: commandId
});

export const DUPLICATE_COMMAND = 'DUPLICATE_COMMAND';
export const DUPLICATE_COMMAND_SUCCESS = 'DUPLICATE_COMMAND_SUCCESS';
export const DUPLICATE_COMMAND_FAILURE = 'DUPLICATE_COMMAND_FAILURE';
export const duplicateCommand = commandId => ({
  type: DUPLICATE_COMMAND,
  payload: commandId
});
